import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as color from '../../../sass/color.scss';
import './LinkCell.scss';

function LinkCell({
  className = '',
  value = '',
  link = null,
  onClick = () => {},
}) {
  return (
    <div
      className={classNames('LinkCell', className)}
      onClick={onClick}
    >
      <a href={link} download>
        {value}
      </a>
    </div>
  );
}

LinkCell.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  background: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
  link: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};

export default LinkCell;
